<template>
    <div class="messages">
        <v-alert v-for="(message, index) in messageList" :key="index" :type="message.type" :value="true" dismissible>
            <div class="icon">
                <svg class="ico">
                    <use xlink:href="#ico-alert-success" v-if="message.type === 'success'"></use>
                    <use xlink:href="#ico-alert-error" v-if="message.type === 'error'"></use>
                    <use xlink:href="#ico-alert-warning" v-if="message.type === 'warning' || message.type === 'info'"></use>
                </svg>
            </div>
            {{message.text}}
        </v-alert>
    </div>
</template>

<script>

export default {
    computed: {
        messageList() {
            return this.$store.getters['message/getList'];
        },
    },
};

</script>

<style type="text/scss" lang="scss">
    @import '../../style/common/Messages.scss';
</style>
